import { t } from '@web/i18n';
import { Button, Input } from '@web/ui/core';
import type { MiceTravelerFilter } from '../travelers/traveler_filter';
import { ActiveFilterTags } from './filters_rail';

interface TravelersToolbarProps {
  filter: MiceTravelerFilter;
  onFilter: (next: Partial<MiceTravelerFilter>) => void;
  /** Coluna de filtros aberta; recolhida, os filtros ativos viram etiquetas aqui. */
  railOpen: boolean;
  count: number;
  allOpen: boolean;
  onToggleAll: () => void;
}

/** Busca, etiquetas dos filtros ativos (coluna recolhida), contagem e "Expandir todos". */
export function TravelersToolbar(props: Readonly<TravelersToolbarProps>) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="w-full max-w-xs">
        <Input
          type="search"
          aria-label={t('mice.filter.search')}
          placeholder={t('mice.filter.search')}
          value={props.filter.text}
          onChange={(e) => {
            props.onFilter({ text: e.target.value });
          }}
        />
      </div>
      {props.railOpen ? null : <ActiveFilterTags filter={props.filter} onFilter={props.onFilter} />}
      <span className="flex-1" />
      <span className="text-meta text-muted-foreground">
        {t('mice.travelers.count', { count: props.count })}
      </span>
      <Button variant="outline" size="sm" onClick={props.onToggleAll}>
        {t(props.allOpen ? 'mice.tree.collapseAll' : 'mice.tree.expandAll')}
      </Button>
    </div>
  );
}
